export const STORE_BONUS_ID_URL_SECTION = ':id';

export const STEP_URL_SECTION = ':step';

export const STEP_ROUTE_PATH = `/storeBonuses/${STORE_BONUS_ID_URL_SECTION}/step/${STEP_URL_SECTION}`;

export const NEW_STORE_BONUS_ROUTE_PATH = `/storeBonuses/new`;

export const MAX_SCHEDULE_SIZE = 14;
